import React, { FC } from "react";
import { PlanbyChannel, PlanbyEvent } from "../../../../models/epg/Models";
import { Epg, Layout, useEpg } from "planby";
import Program from "./ProgramItem";
import Channel from "./ChannelItem";
import useTheme from "../../../../hooks/useTheme";

interface Props {
    date?: string;
    startDateTime?: string;
    endDateTime?: string;
    channels?: PlanbyChannel[];
    events?: PlanbyEvent[];
}

const SingleDayEpg: FC<Props> = ({
    startDateTime = "",
    endDateTime = "",
    channels = [],
    events = [],
}) => {

    const { resolvedTheme } = useTheme();

    const planbyTheme = {
        primary: {
            600: resolvedTheme === "dark" ?  "#1a202c" : "#6c7b8c",
            900: resolvedTheme === "dark" ? "#171923" : "#F4F4F4",
        },
        grey: { 300: "#d1d1d1" },
        white: "#fff",
        green: {
            300: "#2C7A7B",
        },
        loader: {
            teal: "#5DDADB",
            purple: "#3437A2",
            pink: "#F78EB6",
            bg: "#171923db",
        },
        scrollbar: {
            border: "#ffffff",
            thumb: {
                bg: "#e1e1e1",
            },
        },
        gradient: {
            blue: {
                300: resolvedTheme === "dark" ? "#002eb3" : "#5c74e6",
                600: resolvedTheme === "dark" ? "#002360" : "#4d53a3",
                900: resolvedTheme === "dark" ? "#051937" : "#4c6d92",
            },

        },
        text: {
            grey: {
                300: "#a0afc0",
                500: "#718096",
            },
        },
        timeline: {
            divider: {
                bg: "#718096",
            },
        },
    };

    const {
        getEpgProps,
        getLayoutProps,
    } = useEpg({
        epg: events,
        channels: channels,
        startDate: startDateTime,
        endDate: endDateTime,
        dayWidth: 7200,
        sidebarWidth: 100,
        isSidebar: true,
        isTimeline: true,
        isLine: true,
        theme: planbyTheme,
    });

    return (
        <>
            <Epg {...getEpgProps()}>
                <Layout
                    {...getLayoutProps()}
                    renderProgram={({ program, ...rest }) => (
                        <Program
                            key={program.data.id}
                            program={program}
                            {...rest}
                        />
                    )}
                    renderChannel={({ channel }) => (
                        <Channel key={channel.uuid} channel={channel} />
                    )}
                />
            </Epg>
        </>
    );
};

export default SingleDayEpg;